export const ON_SELECT = 'on_select';

export default class ListingFilters extends HTMLElement {
  private currentSelectedFilterButton: HTMLButtonElement | null;
  constructor() {
    super();
    this.currentSelectedFilterButton = null;
  }

  onSelectFilter(buttonEl: HTMLButtonElement) {
    if (this.currentSelectedFilterButton) {
      this.currentSelectedFilterButton.classList.remove('active');
      if (this.currentSelectedFilterButton.innerText === buttonEl.innerText) {
        this.currentSelectedFilterButton = null;
      } else {
        this.currentSelectedFilterButton = buttonEl;
      }
    } else {
      this.currentSelectedFilterButton = buttonEl;
    }
    this.currentSelectedFilterButton?.classList.add('active');
  }

  sendEvent() {
    this.dispatchEvent(new CustomEvent(ON_SELECT, {
      bubbles: true,
      cancelable: true,
      detail: {
        label: this.currentSelectedFilterButton?.dataset?.label,
      },
    }));
  }

  init() {
    const filtersButtons = this.querySelectorAll('button.filter-button');
    filtersButtons.forEach(buttonEl => {
      (buttonEl as HTMLButtonElement).addEventListener('click', (evt: MouseEvent) => {
        this.onSelectFilter(evt.target as HTMLButtonElement);
        this.sendEvent();
      });
    });
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    });
  }
}